// ambilSemua — ambil SELURUH baris dari endpoint berpaginasi, bukan halaman
// pertamanya saja.
//
// ⛔ LAHIR DARI CACAT NYATA YANG SUDAH AKTIF, 5 September 2026.
//
//    Sapuan sengaja membandingkan tiap plafon yang DITANAM di layar dengan
//    jumlah baris SUNGGUHAN di database. Hasilnya:
//
//        raw_material_master   260 baris   plafon layar 200   -> 60 HILANG
//        vendors               197 aktif   plafon layar 200   -> sisa 3
//
//    Enam layar memuat bahan dengan `page_size: 200` sekali panggil:
//    Opname · Adjustments · MaterialIssues · StockLedger · PurchaseRequests ·
//    PurchaseRequestDetail. Keenamnya sudah memotong HARI INI.
//
// ⚠ AKIBATNYA BUKAN "daftar kurang lengkap" — itu yang membuatnya berbahaya:
//
//      Opname          bahan ke-201+ nol pernah muncul untuk DIHITUNG, lalu
//                      sesinya ditutup sebagai hitungan LENGKAP. Selisih palsu
//                      itu jadi dasar KOREKSI STOK yang nol pernah diperiksa.
//      Adjustments     koreksi stok nol bisa memilih bahan itu
//      MaterialIssues  pengeluaran bahan ke produksi BUNTU
//      PurchaseRequest permintaan pembelian nol bisa memesannya
//
//    Nol satu pun berkata "terpotong". Bahannya sekadar NOL ADA di daftar —
//    dan staf menyimpulkan ia belum terdaftar, lalu membuat master kembar.
//
// ⚠ KELAS INI NOL PUNYA PAGAR SAMA SEKALI: nol test, nol gerbang, nol
//   peringatan. Ia cuma muncul kalau ada yang mengukur angka-di-kode terhadap
//   angka-di-database dengan sengaja. Kalau kamu menambah plafon baru,
//   tanyakan dulu: *"berapa nilainya di database tahun depan?"*
//
// ⚠ Pola pindai ini SENGAJA dijadikan satu pembantu, bukan disalin per layar.
//   Menyalinnya enam kali akan melahirkan POLA A berikutnya — perbaikan yang
//   mendarat di satu tempat lalu berhenti (lihat serah terima sesi 23 §1).
//
// Pemakaian:
//     const bahan = await ambilSemua(listMaterials);
//     const aktif = await ambilSemua(listMaterials, { is_active: true });

//: Plafon keras. Bukan "seharusnya cukup" — ia batas supaya layar yang
//: dipanggil pada tabel raksasa nol menggantung selamanya. Kalau sebuah
//: daftar sungguh melewatinya, yang dibutuhkan pencarian di SERVER, bukan
//: plafon yang lebih besar.
const MAKS_PINDAI = 5000;
const UKURAN = 200;

export async function ambilSemua(pemanggil, params = {}, opsi = {}) {
  const ukuran = opsi.ukuran || UKURAN;
  const maks = opsi.maks || MAKS_PINDAI;
  let semua = [];
  for (let hal = 1; (hal - 1) * ukuran < maks; hal += 1) {
    const r = await pemanggil({ ...params, page: hal, page_size: ukuran });
    const batch = r?.data?.items || [];
    semua = semua.concat(batch);
    // Halaman yang TIDAK PENUH berarti habis. Memakai `total` dari jawaban
    // akan menaruh kepercayaan pada angka yang belum tentu dikirim tiap
    // endpoint — panjang halaman selalu ada.
    if (batch.length < ukuran) return semua;
  }
  // ⛔ KELAS H (23 Sep 2026): dulu loop ini BERHENTI DIAM-DIAM di plafon dan mengembalikan
  // 5.000 baris seolah itu semuanya — pemotongan sunyi yang justru ingin dicegah pembantu
  // ini. Melewati plafon = galat yang terlihat; jawabannya pencarian di SERVER.
  throw new Error(`Daftar melewati ${maks} baris — butuh pencarian/saringan di server, bukan pindai penuh.`);
}

export default ambilSemua;
